import { Typography, TypographyProps } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { DashboardCard } from "../../../dashboards/components/DashboardCard"

const useStyles = makeStyles()((_theme) => ({
    dataNumber: {
        fontWeight: "500",
        fontSize: "3rem",
        color: _theme.palette.tailwind.slate[700],
    },
    dataText: {
        fontWeight: "bold",
        fontSize: "1.5rem",
        paddingTop: "0.8rem",
    },
}))

type StandardDashboardCardProps = Readonly<{
    title?: string
    subtitle?: string
    titleTooltip?: string
    data: string | number | undefined
    variant: "text" | "number"
    slotProps?: {
        title?: TypographyProps
        data?: TypographyProps
    }
}>

export function StandardDashboardCard({ title, subtitle, titleTooltip, data, variant, slotProps = {} }: StandardDashboardCardProps) {
    const { classes } = useStyles()
    const { title: titleProps = {}, data: dataProps = {} } = slotProps

    return (
        <DashboardCard title={title} subtitle={subtitle} titleTooltip={titleTooltip} slotProps={{ title: titleProps }}>
            <Typography
                {...dataProps}
                variant="h2"
                className={variant === "number" ? classes.dataNumber : classes.dataText}
            >
                {data}
            </Typography>
        </DashboardCard>
    )
}
